import * as React from 'react';
import { useMemo } from 'react';
import { cn } from '@restworld/utils-common';
export type ProgressBarProps = {
  percent: number;
  customStyles?: string;
  customIndicatorStyles?: string;
};

export const ProgressBar = ({ percent, customIndicatorStyles, ...rest }: ProgressBarProps) => {
  const width = useMemo(() => {
    if (percent > 100) {
      return 100;
    } else if (percent < 0) {
      return 0;
    } else {
      return percent;
    }
  }, [percent]);
  return (
    <ProgressContainer customIndicatorStyles={customIndicatorStyles}>
      <ProgressIndicator style={{ width: `${width}%` }} {...rest} />
    </ProgressContainer>
  );
};

const ProgressContainer = ({ customIndicatorStyles, className, ...props }: any) => (
  <div className={cn('w-full bg-gray-200 rounded-[2px] h-1.5', customIndicatorStyles, className)} {...props} />
);

const ProgressIndicator = ({ customStyles, className, ...props }: any) => (
  <div className={cn('bg-primary-700 h-1.5 rounded-[2px]', customStyles, className)} {...props} />
);
